import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import {check, currentUserGroup, isAbmPseudoLoggedIn, isRdrPseudoLoggedIn} from '../../../utils/tokenUtils';
import Rewards from './navbar-items/rewards';
import AdminLinks from './navbar-items/admin-links';
import LatestNews from './navbar-items/latest-news';
import Information from './navbar-items/information';
import MyStore from './navbar-items/my-store';
import {checkPermission} from '../../common/guards/can';

export function buildRewardLinks(props) {
  const links = [];

  console.log('IGN-2478 - permission check for sell it uploader', checkPermission('handle', 'sell_it_uploader'));
  console.log('IGN-2478 - props.hasSellItOutlet', props.hasSellItOutlet);
  console.log('IGN-2478 - props.hasAutoEposMissingWeeks', props.hasAutoEposMissingWeeks);
  console.log('IGN-2478 - isRdrPseudoLoggedIn()', isRdrPseudoLoggedIn());
  console.log('IGN-2478 - isAbmPseudoLoggedIn()', isAbmPseudoLoggedIn());


  if (checkPermission('view', 'objective_info,objective_performance', 'AND')) {
    if (props.hasStockItOutlet) {
      links.push(<Link to={'/store-performances#stockit'} onClick={() => props.handleMenu()}>Stock IT objectives</Link>);
    }
    links.push(<Link to={'/store-performances'} onClick={() => props.handleMenu()}>Store performance</Link>);
  }
  if (props.userGroup !== 'staff' && props.optedInToPpc) {
    // eslint-disable-next-line max-len
    links.push(<Link to={{ pathname: props.ppcManagementUrl }} target='_blank' onClick={() => props.handleMenu()}>Ignite Mastercard Management</Link>);
  }
  if (checkPermission('view', 'web_app_points')) {
    links.push(<Link to={'/points-statement#owners'} onClick={() => props.handleMenu()}>Points statement</Link>);
  }
  if (checkPermission('handle', 'sell_it_uploader')
    && (props.hasSellItOutlet || props.hasAutoEposMissingWeeks)
    && !isRdrPseudoLoggedIn()
    && !isAbmPseudoLoggedIn()) {
    links.push(<Link to={'/submissions#submit_epos_data'} onClick={() => props.handleMenu()}>Upload EPOS/Invoice</Link>);
  }
  if (checkPermission('view', 'web_app_level') && props.hasSellItOutlet) {
    links.push(<Link to={'/about-ignite'} onClick={() => props.handleMenu()}>Programme levels</Link>);
  }
  return links;
}

const NavbarMainMenu = (props) => {
  const rewardLinks = buildRewardLinks(props);
  return (
    <div className="nav-menu-links-container">
      {check() && props.hasRewardOutlet && !!rewardLinks.length && <Rewards handleMenu={props.handleMenu} links={rewardLinks} />}
      <AdminLinks handleMenu={props.handleMenu} />
      <LatestNews handleMenu={props.handleMenu} />
      <div className="nav-menu-column-container">
        <Information handleMenu={props.handleMenu} />
        {check() && <MyStore handleMenu={props.handleMenu} />}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  hasRewardOutlet: state.viewConfig.profile.attributes['has-reward-outlet'],
  optedInToPpc: state.viewConfig.profile.attributes['opted-in-to-ppc'],
  hasSellItOutlet: state.viewConfig.profile.attributes['has-sell-it-outlet'],
  hasAutoEposMissingWeeks: state.viewConfig.profile.attributes['has-auto-epos-missing-weeks'],
  hasStockItOutlet: state.viewConfig.profile.attributes['has-stock-it-outlet'],
  userGroup: currentUserGroup(),
  ppcManagementUrl: state.ppc.ppcManagementUrl
});

export default connect(mapStateToProps)(NavbarMainMenu);
